import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(enLocale);

export const validIso3166Alpha2CountryCodes = new Set(
  Object.keys(countries.getAlpha2Codes()),
);

export type CountryOption = {
  code: string;
  name: string;
};

export const countrySelectOptions: CountryOption[] = Object.keys(
  countries.getAlpha2Codes(),
)
  .map((code) => ({
    code,
    name:
      countries.getName(code, 'en', { select: 'official' }) ??
      countries.getName(code, 'en') ??
      code,
  }))
  .sort((a, b) => a.name.localeCompare(b.name, 'en'));

const countryNamesByCode = new Map(
  countrySelectOptions.map((country) => [country.code, country.name]),
);

/** Human-readable English label while preserving the canonical stored code. */
export function formatCountryLabel(code: string): string {
  const normalized = code.trim().toUpperCase();
  const name = countryName(normalized);
  return name ? `${name} (${normalized})` : normalized;
}

/** Official English country name for authored communication personalization. */
export function countryName(code: string | null | undefined): string | null {
  const normalized = code?.trim().toUpperCase();
  if (!normalized) return null;
  return countryNamesByCode.get(normalized) ?? null;
}

export function isValidIso3166Alpha2CountryCode(code: string): boolean {
  return validIso3166Alpha2CountryCodes.has(code);
}
